export const DEFAULT_ICON = 'mdi-text-short'

// Loop through passed in mdDefault list and set any prepopulated values where applicable
export function generatePrepopulatedMds (mdDefaults) {
  const metadatas = []
  for (const mdDefault of mdDefaults) {
    if (!mdDefault.prepopulate) {
      continue
    }
    metadatas.push(generateDefaultMdValue(mdDefault))
  }
  return metadatas
}

// Generate blank default value for metadata row
export function generateBlankValue () {
  return {
    value: null
  }
}

// Generate a default metadata row with any default values
export function generateDefaultMdValue (mdDefault) {
  const values = []
  if (mdDefault.default_value.length < 1) {
    values.push(generateBlankValue())
  }
  else {
    values.push(...mdDefault.default_value)
  }

  return {
    metadata_default: mdDefault,
    key: mdDefault.key,
    title: mdDefault.title,
    color: mdDefault.color,
    icon: mdDefault.icon,
    values
  }
}

// Check if a metadata value has been selected from the dropdown
export function checkDropdownOptionIsSelected (against, opt) {
  return against.value === opt.value
}

// Select one of the dropdown items
export function selectDropdownOption (obj, opt) {
  obj.value = opt.value
}

// Generate a fresh custom metadata key-pair
export function generateCustomMd () {
  return {
    metadata_default: null,
    key: null,
    title: null,
    color: null,
    icon: null,
    values: [generateBlankValue()]
  }
}

// Reformat the metadata details for submission to the backend
export function parseForSubmission (rows) {
  const arr = []
  for (const metadata of rows) {
    const values = []
    for (const vPair of metadata.values) {
      if (vPair.value && !values.find(item => item.value === vPair.value)) {
        values.push(vPair)
      }
    }

    if (values.length < 1) {
      continue
    }

    arr.push({
      id: metadata.id || null,
      color: metadata.color,
      metadata_default_id: metadata.metadata_default ? metadata.metadata_default.id : null,
      key: metadata.metadata_default ? metadata.metadata_default.key : metadata.key,
      title: metadata.metadata_default ? metadata.metadata_default.title : metadata.title,
      icon: metadata.metadata_default ? metadata.metadata_default.icon : null,
      values
    })
  }
  return arr
}
